import type React from 'react'
import PropTypes from 'prop-types'
import './styles.css'

interface AppInputIconOwnProps {
    disabled?: boolean
    className?: string
    iconLeft?: React.ReactElement
    iconRight?: React.ReactElement
    position?: string
    onSubmit: React.FormEventHandler<HTMLFormElement>
}

type AppInputIconProps = AppInputIconOwnProps &
    React.InputHTMLAttributes<HTMLInputElement>

const AppInputIcon: React.FC<AppInputIconProps> = ({
    disabled = false,
    className,
    iconLeft,
    iconRight,
    //onSubmit,
    position = 'between',
    ...rest
}) => {
    return (
        <label
            className={`flex gap-2 justify-${position} text-left input bg-white h-[42px]`}
        >
            {iconLeft && (
                <button type="submit" className="text-gray-600">
                    {iconLeft}
                </button>
            )}
            <input
                className={`${
                    disabled && 'disabled'
                } focus:outline-none outline-none ${className}`}
                {...rest}
            />
            {iconRight && (
                <button type="submit" className="text-gray-600">
                    {iconRight}
                </button>
            )}
        </label>
    )
}

AppInputIcon.propTypes = {
    label: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    classNameForm: PropTypes.string,
    iconLeft: PropTypes.element,
    iconRight: PropTypes.element,
    onSubmit: PropTypes.func.isRequired,
    rest: PropTypes.object,
}

export default AppInputIcon
